import { UserModel } from '@/models/user'
import { ProspectModel } from '@/models/prospect'

export class ForumResponseReaction {
  constructor({
    id,
    emoji,
    isAnimated,
    isModerator,
    isOwnReaction,
    userId,
    prospectId,
    user,
    prospect,
    anonymousId
  } = {}) {
    this.id = id || null
    this.emoji = emoji || ''
    this.isAnimated = isAnimated || false
    this.isModerator = isModerator || false
    this.isOwnReaction = isOwnReaction || false
    this.userId = userId || null
    this.prospectId = prospectId || null
    this.user = user ? new UserModel(user) : null
    this.prospect = prospect ? new ProspectModel(prospect) : null
    this.anonymousId = anonymousId || null
  }

  static parseFromApi({ reaction, users, prospects, user, prospect }) {
    const _users = users?.map((user) => UserModel.parseFromApi({ user })) || []
    const _prospects = prospects?.map((prospect) => ProspectModel.parseFromApi({ prospect })) || []

    const _user = user
      ? UserModel.parseFromApi({ user })
      : _users.find((u) => u.id === reaction?.userId) || null
    const _prospect = prospect
      ? ProspectModel.parseFromApi({ prospect })
      : _prospects.find((p) => p.id === reaction?.prospectAccountId) || null

    return new ForumResponseReaction({
      id: reaction?.id,
      emoji: reaction?.emoji,
      isAnimated: reaction?.isAnimated,
      isModerator: reaction?.isModerator,
      isOwnReaction: reaction?.isOwnReaction,
      userId: reaction?.userId,
      prospectId: reaction?.prospectAccountId,
      user: _user || null,
      prospect: _prospect || null,
      anonymousId: reaction.anonymousId
    })
  }
  convertToApi() {}
}
